import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=716a52a5&scoped=true&"
import script from "./ProcessICPERMIT.vue?vue&type=script&lang=js&"
export * from "./ProcessICPERMIT.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=716a52a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a52a5",
  null
  
)

export default component.exports